import styled from 'styled-components';

export default styled.div`
  background: ${props => props.background};
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 500;
  height: 20px;
  line-height: 21px;
  position: relative;
  text-align: center;
  text-indent: 1px;
  width: 20px;

  .tooltip-text {
    background-color: #F8F6F4;
    border-radius: 16px;
    box-shadow: 0px 2px 4px rgba(2, 36, 30, 0.15);
    color: ${props => props.theme.textColor};
    right: 1.5rem;
    max-width: 300px;
    padding: 1rem 1.5rem;
    position: absolute;
    text-align: center;
    width: 300px;
    visibility: hidden;
    z-index: 9;
  }

  &:hover {
    .tooltip-text {
      visibility: visible;
    }
  }

  .ef-location {
    right: -6.5rem;
    bottom: .25rem;

    ${props => props.theme.media.xs} {
      right: -1.5rem;
    }
 
    ${props => props.theme.media.md} {
      right: 0rem;
    }
  }
`;
